import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import SaleSharedFile from 'components/Tvendo/Sale/Operations/SaleOrder/SaleSharedFile';

export default function WebOrder() {
  return (
    <SaleSharedFile
      title="Listado de pedidos digitados web"
      excelName="Pedidos_digitados_web"
      originType="WO"
      permission={{
        show: ConstantPermissions.SALE_ORDERS_SHOW,
        store: ConstantPermissions.SALE_ORDERS_STORE
      }}
    />
  );
}
